
  var _styles = {
  "modal-bottom-button": {
    "width": "6.70667rem",
    "height": "1.2rem",
    "borderRadius": "7.45333rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "modal-bottom-button-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.48rem",
    "lineHeight": "0.64rem"
  }
};



  module.exports = _styles;
  